import type { ReactElement } from 'react';
import { cn } from '@/shared/ui';

interface StoreCategoryTabProps {
  readonly label: string;
  readonly isSelected: boolean;
  readonly onSelect: () => void;
}

/**
 * 대분류 탭 한 칸 — 글자 아래 2px 밑줄로 선택을 표시한다.
 * 밑줄은 탭 줄의 얇은 선(1px) 위에 겹쳐 앉는다(-mb-px) — 선택한 탭이 선을 끊고 굵게 이어지는 모양.
 */
export const StoreCategoryTab = ({
  label,
  isSelected,
  onSelect,
}: StoreCategoryTabProps): ReactElement => (
  <li className="-mb-px shrink-0">
    <button
      type="button"
      aria-pressed={isSelected}
      onClick={onSelect}
      className={cn(
        'flex h-12 cursor-pointer items-center border-b-2 text-[15px] whitespace-nowrap transition-colors sm:text-base',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        isSelected
          ? 'border-foreground font-bold text-foreground'
          : 'border-transparent text-muted-foreground hover:text-foreground',
      )}
    >
      {label}
    </button>
  </li>
);
